<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <button class="btn btn-success" @click="save">{{ 'Create barcode range' }}</button>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>{{ 'Barcode type' }}</label>
              <input class="form-control" v-model="barcode_range.barcode_type" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label>{{ 'Range from' }}</label>
              <input class="form-control" v-model="barcode_range.serial_from" />
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>{{ 'Range to' }}</label>
              <input class="form-control" v-model="barcode_range.serial_to" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import Alerts from '@/utils/alerts.js';
export default {
  data: function () {
    return {
      barcode_range: { serial_from: '', serial_to: '', barcode_type: '' }
    };
  },
  methods: {
    save: function () {
      Api.create('barcode_ranges', this.barcode_range)
        .then(({ data }) => {
          Alerts.success({ title: 'Barcode range created', detail: '' });
          this.$router.push({ name: 'barcode_ranges' });
        })
        .catch(({ errors }) => {
          Alerts.danger(errors[0]);
        });
    }
  },
  mounted: function () {
    this.setBreadcrumbs([
      { to: { name: 'barcode_ranges' }, text: 'Global barcode ranges' },
      { to: { name: 'barcode_range_create' }, text: 'Create barcode range' }
    ]);
    Api.findAll('barcode_ranges').then(({ data }) => {
      this.barcode_ranges = data;
    });
  }
};
</script>

<style scoped></style>
